<template>
  <div class="pt-5">
    <EmptyList
      :linkText="$t('auth.noOrganization.button.createOrganization')"
      :linkTo="{ name: 'createOrganization-default' }"
      :title="$t('auth.noOrganization.text.title')"
      :subTitle="$t('auth.noOrganization.text.subtitle')"
    />
  </div>
</template>

<script>
import EmptyList from '@/components/EmptyList'

export default {
  components: {
    EmptyList,
  },
  beforeCreate() {
    this.$store.commit('HIDE_BASE_MENU', 'NoOrganization')
    this.$store.commit('SHOW_BASE_USER_CONTROLS')
  },
}
</script>

<style></style>
